export default "__VITE_ASSET__BQ4k4JSF__"